export default function OnboardingMobileAnchorElement() {
  return (
    <div>
      <div id="portal-mobile-rewards1" />
      <div id="portal-mobile-offers1" />
    </div>
  );
}
